"use strict";const d=()=>new Promise(e=>{document.body?e():document.addEventListener("DOMContentLoaded",()=>{e()})});export default d;
//# sourceMappingURL=whenDOMReady.js.map
